import React from 'react';
import '../styles/StartupLanding.css';

const StartupHeader = () => {
    return (
        <header className="startup-header">
            <div className="header-content">
                <div className="logo">MoveFlair</div>
                <nav>
                    <a href="mailto:hello@moveflair.com" className="contact-link">
                        Contact Us
                    </a>
                </nav>
            </div>
        </header>
    );
};

export default StartupHeader;